module.exports = __webpack_public_path__ + "static/media/multiplePages.38ccc665.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor/components/Result/images/multiplePages.svg
// module id = 860
// module chunks = 0